import { Icon } from "@iconify/react";
import { useState } from "react";
import { toast } from "sonner";
import { useTicketApi } from "@/api/tickets";
import { ExtendedInfoList, parseExtendedInfo } from "@/components/extended-info-list";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/locales/i18n-provider";
import { formatFileSize, saveBlobAs } from "../../utils/ticket-attachments";
import { LinkedEntityCard, type LinkedEntityRendererProps } from "./linked-entity-card";

export function GenericLinkedEntity({ ticketId, link }: LinkedEntityRendererProps) {
  const api = useTicketApi();
  const { t, intlLocale } = useI18n();
  const [downloading, setDownloading] = useState<string | null>(null);
  return (
    <LinkedEntityCard icon="tabler:database" link={link} title={link.entityType} type={link.systemCode}>
      {link.data && Object.keys(link.data).length > 0 ? (
        <ExtendedInfoList
          className="mt-3 border-t pt-3"
          entries={parseExtendedInfo(JSON.stringify(link.data), t("extendedInfo.value"), t("extendedInfo.raw"))}
        />
      ) : null}
      {link.contents?.length ? (
        <div className="mt-3 flex flex-wrap gap-2">
          {link.contents.map((content) => (
            <Button
              key={content.key}
              disabled={downloading !== null}
              size="sm"
              type="button"
              variant="outline"
              onClick={async () => {
                setDownloading(content.key);
                try {
                  saveBlobAs(await api.downloadLinkedEntityContent(ticketId, link.id, content.key), content.fileName);
                } catch {
                  toast.error(t("tickets.linked.downloadFailed"));
                } finally {
                  setDownloading(null);
                }
              }}
            >
              <Icon icon={downloading === content.key ? "tabler:loader" : "tabler:download"} />
              {content.fileName}
              {content.size != null ? ` · ${formatFileSize(content.size, intlLocale)}` : ""}
            </Button>
          ))}
        </div>
      ) : null}
    </LinkedEntityCard>
  );
}
